import axios from "axios";
import constants from "../../utils/constants";

const API_URL = constants.FIXOR;

const save = (client, instance, request,id) => {
    return axios.post(`${API_URL}bymaOR/newOrderSingle?client=${client}&instance=${instance}&id=`, request);
};

const getOrders = (client, instance) => {
    return axios.get(`${API_URL}bymaOR/findAll?client=${client}&instance=${instance}`);
};

const getOrderById = (client, instance,id) => {
    return axios.get(`${API_URL}bymaOR/findById?client=${client}&instance=${instance}&id=${id}`);
};

const orderSingle = {
    save,
    getOrders,
    getOrderById
}

export default orderSingle;
